import IBAN from 'iban';

export function ibanPrefixDe(value, prefix = 'DE') {
  value = value.toUpperCase();
  // Add missing de prefix
  if (value.indexOf(prefix) === -1) {
    value = prefix + value;
  }
  return IBAN.isValid(value);
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-form-validation/src/rules/ibanPrefixless.js